import { render, staticRenderFns } from "./contractMsg.vue?vue&type=template&id=78c88150&scoped=true&"
import script from "./contractMsg.vue?vue&type=script&lang=js&"
export * from "./contractMsg.vue?vue&type=script&lang=js&"
import style0 from "./contractMsg.vue?vue&type=style&index=0&id=78c88150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c88150",
  null
  
)

export default component.exports